import { EVENT_HOME_BANNER_CHRISTMAS } from './EventChristmasData';
import { EVENT_BANNER_FRIEND, EVENT_COMPONENT_FRIEND } from './EventFriendData';
import {
  EVENT_BANNER_MARKETINGAGREE,
  EVENT_COMPONENT_MARKETINGAGREE,
  EVENT_HOME_BANNER_MARKETINGAGREE,
} from './EventMarketingAgreeData';
import {
  EVENT_BANNER_REVIEW_CONTEST,
  EVENT_COMPONENT_REVIEW_CONTEST,
  EVENT_HOME_BANNER_REVIEW_CONTEST,
} from './EventReviewContestData';
import {
  EVENT_HOME_BANNER_GC_CARE,
} from './EventGCCareData';
import {
  EVENT_BANNER_REFUND,
  EVENT_COMPONENT_REFUND,
} from './EventRefundData';
import { 
  EVENT_BANNER_MIRAEASSET, 
  EVENT_COMPONENT_MIRAEASSET, 
  EVENT_HOME_BANNER_MIRAEASSET
} from './EventMiraeassetData';
import { EVENT_HOME_BANNER_BLOG } from './EventBlogData';
import { EVENT_HOME_BANNER_FALL } from './EventFallData';

export const EVENT_BANNER_LIST = [
  EVENT_BANNER_MIRAEASSET,
  EVENT_BANNER_REFUND,
  EVENT_BANNER_MARKETINGAGREE,
  EVENT_BANNER_REVIEW_CONTEST,
  EVENT_BANNER_FRIEND,
];
export const EVENT_HOME_BANNER_LIST = [
  EVENT_HOME_BANNER_BLOG,
  EVENT_HOME_BANNER_MIRAEASSET,
  EVENT_HOME_BANNER_CHRISTMAS,
  EVENT_HOME_BANNER_FALL,
  EVENT_HOME_BANNER_MARKETINGAGREE,
  EVENT_HOME_BANNER_REVIEW_CONTEST,
  EVENT_HOME_BANNER_GC_CARE,
];
export const EVENT_LIST = [
  EVENT_COMPONENT_MIRAEASSET,
  EVENT_COMPONENT_REFUND,
  EVENT_COMPONENT_MARKETINGAGREE,
  EVENT_COMPONENT_REVIEW_CONTEST,
  EVENT_COMPONENT_FRIEND,
];
